import React, { useEffect, useContext, useState, Fragment } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import useLogicForm from '../../hooks/useLogicForm';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Spinner } from 'react-bootstrap';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';
import { Modal } from 'react-bootstrap';
import { alertService } from '../../services/alertservice';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import { Alert } from '../../componentes/ui/Alert';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import MiDataTable from '../../componentes/ui/MiDataTable';
import FormInput from '../../componentes/formulario/FormInput';
import FormRow from '../../componentes/formulario/FormRow';
import MiDataTableLarge from './MiDataTableLarge';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import TextArea from '../../componentes/formulario/TextArea';
import UplmPlusBtn from '../../componentes/formulario/UpmlPlusBtn/UplmPlusBtn';
import { getApiUrl, axiosPost, encryptData, getAhorayyyymmdd, getDecodedCookie, getTitle, setStockOptionsSelectUbiLarge, getStockOptionsSelectUbi } from '../../helpers/helperApp';

$.DataTable = DataTable;

function LargeComp(props) {

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
   
    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom, tipDocAlc, centroActivo } = useContext(LoginContext);

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg } = useLogicForm()    

    const [ confPantalla, saveConfPantalla ] = useState(confApp);
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ docSeleccionado, saveDocSeleccionado ] = useState(null);
    const [ idFiltro, saveIdFiltro ] = useState(tipDocAlc);
    const [ documentos, saveDocumentos ] = useState([]);
    const [ reloadKpi, saveReloadKpi ] = useState(0);
    const [ loading, saveLoading ] = useState(false);
    const [ lineas, saveLineas ] = useState([]);
    const [ unidad, saveUnidad ] = useState({value: 0, label: ""});
    const [ cantidad, saveCantidad ] = useState(0);
    const [ ubicacion, saveUbicacion ] = useState({value: 0, label: ""});
    const [ showModalEditCabecera, saveShowModalEditCabecera ] = useState(false);
    const [ idestCab, saveIdEstCab ] = useState();
    const [ nom1Cab, saveNom1Cab ] = useState();
    const [ nom1EnCab, saveNom1EnCab ] = useState();
    const [ fec1Cab, saveFec1Cab ] = useState();
    const [ fec2Cab, saveFec2Cab ] = useState();
    const [ fec3Cab, saveFec3Cab ] = useState();
    const [ notasCab, saveNotasCab ] = useState();
    const [ notasEnCab, saveNotasEnCab ] = useState();
    const [ loadingActionModal, saveLoadingActionModal ] = useState(false);
    const [ showModalEditLinea, saveShowModalEditLinea ] = useState(false);
    const [ idLin, saveIdLin ] = useState();
    const [ idestLin, saveIdEstLin ] = useState();
    const [ num3Lin, saveNum3Lin ] = useState();
    const [ nom1Lin, saveNom1Lin ] = useState();
    const [ nom1EnLin, saveNom1EnLin ] = useState();
    const [ fec1Lin, saveFec1Lin ] = useState();
    const [ fec2Lin, saveFec2Lin ] = useState();
    const [ fec3Lin, saveFec3Lin ] = useState();
    const [ notasLin, saveNotasLin ] = useState();
    const [ notasEnLin, saveNotasEnLin ] = useState();
    const [ showModalNewAlb, saveShowModalNewAlb ] = useState(false);    
    const [ idSelectPAlb, saveIdSelectPAlb ] = useState(0);
    const [ idCentro, saveIdCentro ] = useState(0);
    const [ docBloqueado, saveDocBloqueado ] = useState(false);
    const [ adjuntos, saveAdjuntos ] = useState([]);
    const [ adjuntosCabecera, saveAdjuntosCabecera ] = useState([]);
    const [ idDocParam, saveIdDocParam ] = useState(null);

     useEffect( () => {                
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                     
                    document.title = getTitle(confPantalla.config.trad, confPantalla.largecomp.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                                                
                        saveIdFiltro(tipDocAlc);
                        if( props.location.state ){
                            if( "iddoc" in props.location.state ){
                                // Nos llega el documento como parámetro                                    
                                saveIdDocParam(props.location.state.iddoc);                                                               
                            }                               
                        }                                
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 
    },[confPantalla])

    const handleGetLineas = async (idRowSeleccionado, idTabla, datosTabla, docTablaSeleccionado) => { 

        if(docTablaSeleccionado.length > 0){

            docTablaSeleccionado && docTablaSeleccionado[0] && docTablaSeleccionado[0].idest == 9 ? saveDocBloqueado(true) : saveDocBloqueado(false);

            saveDocSeleccionado(docTablaSeleccionado[0]);

            // Seleccionar documento en la tabla
            saveLoading(true);


            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", JSON.stringify(docTablaSeleccionado[0].id));
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largecomp.controles.datatableres.getdata, data, source.token);            
            if( typeof respuesta.data !== "string" ){                               
                saveLineas(respuesta.data);                
            }else if( typeof respuesta.data === "string" ){            
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 
            saveLoading(false);
        }else{
            // Quitar selección
            saveLineas([]);
            saveDocSeleccionado(null);
            saveDocBloqueado(false)
        }

    }

    const fnReloadTablaLineas = async (idDoc) => {             
                    
        if(idDoc){
            saveLoading(true);
    
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", idDoc["iddoc"]);
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largecomp.controles.datatableres.getdata, data, source.token);            
            if( typeof respuesta.data !== "string" ){                               
                saveLineas(respuesta.data);                
            }else if( typeof respuesta.data === "string" ){            
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 
        }
        saveLoading(false);
    }

    //***** AÑADIR LINEA *****//
    const addLinea = async() => {
        if( unidad != 0 ){
            // Editar documento
            saveLoading(true);                 
            accionesDoc(docSeleccionado.id, idFiltro, unidad, cantidad, ubicacion, "modificar")             
        }else{
            // Error. Debe seleccionar una unidad            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.largecomp.errorunidad.title}`, {autoClose: false});
        }
    }

    const accionesDoc = async (idDocActual, idFiltro, unidad, cantidad, ubicacion, accion) => {
        const data = new FormData();       
        data.append("validacion", apiKey());
        data.append("iddoc", idDocActual); 
        data.append("tipdoc", idFiltro); 
        data.append("iduni", unidad.value); 
        data.append("num1", cantidad); 
        data.append("idubi", ubicacion.value);
        data.append("accion", accion)                    
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/edirap/actionsedirap', data);
        saveLoading(false);       
        if( typeof respuesta.data !== "string" ){           
            saveUnidad({value: 0, label: ""});
            saveCantidad(0);
            saveUbicacion({value: 0, label: ""});            
            const editedDoc = await reloadDoc(respuesta.data.idClon);
            if(editedDoc){
                await handleGetLineas(`#row-${editedDoc.id}`, "edirap", documentos, [{id : docSeleccionado.id}]);                         
                saveDocSeleccionado(editedDoc);
            }                  
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largecomp.linesuccess.title}`, {autoClose: true}); 
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        } 
    }

    //***** NUEVA OPERACION *****//
    const handleNewAlb = () => {
        saveIdDocParam(null);
        saveShowModalNewAlb(true);
        saveIdCentro(centroActivo != "" ? centroActivo : 0);
        saveIdSelectPAlb(0);
        saveFec1Cab(getAhorayyyymmdd()+" 00:00");
        saveNom1Cab("");
        saveNom1EnCab("");
    }
    
    const accionNew = async () => {
        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idplan", idSelectPAlb);
        data.append("idcen", idCentro);
        data.append("fec1", fec1Cab); 
        data.append("nom1", nom1Cab);            
        data.append("nom1_en", nom1EnCab);                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largecomp.controles.modalnew.new.senddata, data, source.token);        
                
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }else{            
            saveUnidad(0);
            saveCantidad(0);
            saveUbicacion(0);                      
            saveReloadKpi(reloadKpi+1);            
            const editedDoc = await reloadDoc(respuesta.data.idClon);
            if(editedDoc){
                await handleGetLineas(`#row-${editedDoc.id}`, "edirap", documentos, [editedDoc]);
                saveDocSeleccionado(editedDoc);
            }                  
        }
        
        saveLoadingActionModal(false);
        saveShowModalNewAlb(false);
    }


    //***** EDITAR CABECERA *****//
    const btnEditCabecera = (e) => {
        e.preventDefault();        
        saveIdEstCab(docSeleccionado.idest);
        saveFec1Cab(docSeleccionado.fec1);
        saveFec2Cab(docSeleccionado.fec2);
        saveFec3Cab(docSeleccionado.fec3);
        saveNom1Cab(docSeleccionado.nom1);
        saveNom1EnCab(docSeleccionado.nom1_en);
        saveNotasCab(docSeleccionado.notas);
        saveNotasEnCab(docSeleccionado.notas_en);
        saveShowModalEditCabecera(true);
    }
    
    const accionBtnEditCabecera = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", docSeleccionado.id);
        data.append("idest", idestCab);            
        data.append("fec1", fec1Cab);
        data.append("fec2", fec2Cab);
        data.append("fec3", fec3Cab);
        data.append("nom1", nom1Cab);
        data.append("nom1_en", nom1EnCab);
        data.append("notas", notasCab);
        data.append("notas_en", notasEnCab);
        data.append("origen", "/largecomp");
        // Adjuntos existentes       
        const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        for(let i=0; i<inputs.length; i++){
            data.append(inputs[i].name, inputs[i].value);
        }          
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntosCabecera.length; i++ ){            
            if( !adjuntosCabecera[i].urlAdd ){
                data.append(adjuntosCabecera[i]["id"]+"[]", adjuntosCabecera[i]);
            }
        }          
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.largecomp.controles.modaleditcabecera.updatecabecera.senddata,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });             

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            const editedDoc = await reloadDoc();
            if(editedDoc){                
                saveDocSeleccionado(editedDoc);
            }            
            saveReloadKpi(reloadKpi+1);                         
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largecomp.controles.modaleditcabecera.updatecabecera.success.title}`, {autoClose: true});
        }
                
        //Reseteamos los input de los adjuntos
        let adjs = document.querySelectorAll("input[type=file]");            
        for(let i=0; i<adjs.length; i++){
            adjs[i].value = null;
            adjs[i].files = null;
        }

        //Reseteamos los adjuntos pendientes de subir.
        saveAdjuntosCabecera([]);

        saveLoadingActionModal(false);
        saveShowModalEditCabecera(false);
    }

    //***** EDITAR LINEAS *****//
    const btnEditLinea = (e, rowData) => {        
        saveIdLin(rowData.id);
        saveIdEstLin(rowData.idest);
        saveNum3Lin(rowData.coste);
        saveFec1Lin(rowData.fec1);
        saveFec2Lin(rowData.fec2);
        saveFec3Lin(rowData.fec3);
        saveNom1Lin(rowData.descripcionlin);
        saveNom1EnLin(rowData.descripcionlin_en);
        saveNotasLin(rowData.notas);
        saveNotasEnLin(rowData.notas_en);
        saveShowModalEditLinea(true);
    }

    const accionBtnEditLinea = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", idLin);        
        data.append("idest", idestLin);
        data.append("num3", num3Lin);
        data.append("fec1", fec1Lin);
        data.append("fec2", fec2Lin);
        data.append("fec3", fec3Lin);
        data.append("nom1", nom1Lin);
        data.append("nom1_en", nom1EnLin);
        data.append("notas", notasLin);
        data.append("notas_en", notasEnLin);
        // Adjuntos existentes       
        const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        for(let i=0; i<inputs.length; i++){
            data.append(inputs[i].name, inputs[i].value);
        }          
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntos.length; i++ ){            
            if( !adjuntos[i].urlAdd ){
                data.append(adjuntos[i]["id"]+"[]", adjuntos[i]);
            }
        }          
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.largecomp.controles.modaleditlinea.updatelinea.senddata,data,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });     
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            const editedDoc = await reloadDoc();
            await handleGetLineas(`#row-${docSeleccionado.id}`, "edirap", documentos, [editedDoc]);            
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largecomp.controles.modaleditlinea.updatelinea.success.title}`, {autoClose: true});
        }  

        //Reseteamos los input de los adjuntos
        let adjs = document.querySelectorAll("input[type=file]");            
        for(let i=0; i<adjs.length; i++){
            adjs[i].value = null;
            adjs[i].files = null;
        }

        //Reseteamos los adjuntos pendientes de subir.
        saveAdjuntos([]);

        saveLoadingActionModal(false);
        saveShowModalEditLinea(false);
    }

    const reloadDoc = async (idDoc=null) => {
        
        let reloadedDoc = [];

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idFiltro", idFiltro);
        data.append("idparam", idDoc == null ? docSeleccionado.id : idDoc);            
        data.append("reloaddoc", true);                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/edirap/getdocumentosedirap", data, source.token);        
        if( typeof respuesta.data !== "string"){
            reloadedDoc = respuesta.data[0];
        }

        return reloadedDoc;
        
    }

    const setUbiDef = async (selectedItem, nameOfComponent) => {                
        if(docSeleccionado.defubicen != 0){                         
            let optionWithStock = await getStockOptionsSelectUbi([{value: docSeleccionado.defubicen, label: docSeleccionado.defubicenlabel}], selectedItem.value);                   
            optionWithStock = setStockOptionsSelectUbiLarge(optionWithStock);
            saveUbicacion(optionWithStock[0]);
        } 
    }

    const selectIdParam = async () => { 
        if(idDocParam != null){
            const editedDoc = await reloadDoc(idDocParam);
            if(editedDoc){                        
                await handleGetLineas(`#row-${editedDoc.id}`, "edirap", documentos, [{id : idDocParam}]);                         
                saveDocSeleccionado(editedDoc);
                editedDoc && editedDoc.idest == 9 ? saveDocBloqueado(true) : saveDocBloqueado(false);
            } 
        }       
    }


    //***** HANDLES *****//
    const handleCantidad = (e) => {
        const { name, value } = e.target;
        saveCantidad(value)        
    }

    const handleSelectModal = (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInputModal = (e, save) => {        
        save(e.target.value)
    }

    return (
        <div className="App wrapper">
            <div>
                {loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div>
                    :
                    null
                }
            </div>
            {
                confPantalla !== undefined
                    ?
                    <Fragment>
                        <Alert fondo={true} />
                        <Menusup
                            props={props}
                        />
                        <Sidebar
                            props={props}
                        />
                    </Fragment>
                    :
                    null
            }
            <div className="content-wrapper">
                <div className="content-header">
                </div>
                <section className="content">
                    {
                        !tieneNivel
                            ?
                            <PermissionRefused
                                traduction={confPantalla.config.trad.components.permissionrefused}
                            />
                            :
                            <Fragment>
                                {
                                loadedConf === true && confPantalla !== undefined
                                    ?
                                    <Section
                                        tituloenhtml={true}
                                        titulo={
                                            docSeleccionado == null
                                                ?
                                                confPantalla.largecomp.section.titulo
                                                :
                                                docSeleccionado.nomdoc
                                        }
                                        icono={confPantalla.largecomp.section.icono}
                                        col={confPantalla.largecomp.section.col}
                                        formulario={ {id: docSeleccionado != null ? docSeleccionado.id : null} }
                                        idPrin={docSeleccionado != null ? docSeleccionado.id : null }
                                        borderHeader={docSeleccionado != null ? docSeleccionado.color : null}
                                        recurrencia={docSeleccionado != null ? docSeleccionado.recurrencia : null}
                                        editCabEdirap={btnEditCabecera}
                                        idDocGoToRunCicCfg={docSeleccionado != null ? docSeleccionado.id : 0}
                                        infoDocActual={docSeleccionado}
                                        informes={confPantalla.largecomp.controles.informes}
                                        docBloqueado={docBloqueado}
                                        origen={"largecomp"}                                        
                                    >
                                        <Kpi
                                            conf={ confPantalla.largecomp.controles.kpi }
                                            getDataTable1 = { confPantalla.largecomp.controles.datatable.getdata }
                                            saveDataTable1 = { saveDocumentos }                           
                                            saveLoadingTable = { saveLoading }
                                            filtro={ confPantalla.largecomp.controles.kpi.tipdoc }
                                            idFiltro={ idFiltro }                                           
                                            forceReload={reloadKpi}                                            
                                            readOnlyFiltro={"readonly"}
                                            callBackLoaded={ selectIdParam }
                                        />
                                        <MiDataTable 
                                            estadoForm= { "" }
                                            formulario={ {id:0} }
                                            id={"docLargeAlb"}
                                            columnas={confPantalla.largecomp.controles.datatable.columns}
                                            data={documentos}
                                            buttons={confPantalla.largecomp.controles.datatable.buttons}
                                            ordering={confPantalla.largecomp.controles.datatable.ordering}
                                            order={confPantalla.largecomp.controles.datatable.order}
                                            searching={confPantalla.largecomp.controles.datatable.searching}
                                            paging={confPantalla.largecomp.controles.datatable.paging}
                                            select={confPantalla.largecomp.controles.datatable.select}
                                            pagelength={confPantalla.largecomp.controles.datatable.pagelength}                                            
                                            // loadingTable={loading}
                                            columnactions={confPantalla.largecomp.controles.datatable.columnactions.title}
                                            linkColumns={confPantalla.largecomp.controles.datatable.linkColumns}
                                            traduction={confPantalla.config.trad.components.datatable}                                            
                                            functionAfterSelect={handleGetLineas}
                                            selectIds={docSeleccionado != null ? docSeleccionado.id : ""}
                                            selectIdsKeySearch={"id"}
                                        />
                                        {
                                            docSeleccionado == null
                                            ?
                                                <div className='text-center'>
                                                    <Button 
                                                        clases={ "col-5 mt-2 mb-4" }
                                                        estadoForm={ false }
                                                        color={ "success" }  
                                                        type="button" 
                                                        icono={ "" }   
                                                        id="btncreatealb"     
                                                        texto={ confPantalla.largecomp.btncreatealb.title }   
                                                        accion={ handleNewAlb } 
                                                        disabled={ false }
                                                    /> 
                                                </div>
                                            :
                                                null
                                        }
                                        <FormRow clases={"formedirap"}>                                            
                                            {/* <h4 className='col-12'>{docSeleccionado == null ? confPantalla.largecomp.modocreacion.title :  confPantalla.largecomp.modoedicion.title}</h4> */}
                                            <MiSelectLarge
                                                regActual={docSeleccionado ? docSeleccionado.id : 0}
                                                value={unidad}
                                                saveValue={saveUnidad}                                                
                                                label={confPantalla.largecomp.controles.iduni.label.title}
                                                col={4}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.largecomp.controles.iduni.datatype}
                                                dataSql={confPantalla.largecomp.controles.iduni.data}
                                                multiLinea={confPantalla.largecomp.controles.iduni.multilinea}
                                                readOnly={docBloqueado == true || docSeleccionado == null ? true : false}
                                                functionAfterChange={setUbiDef} 
                                            />
                                            <FormInput 
                                                estadoForm= { "" }
                                                value=      { cantidad }
                                                loading=    { loadReg ? true : false }
                                                id=         { confPantalla.largecomp.controles.num1.id }   
                                                type=       { confPantalla.largecomp.controles.num1.type }  
                                                name=       { confPantalla.largecomp.controles.num1.name }   
                                                label=      { confPantalla.largecomp.controles.num1.label }                                                       
                                                placeholder={ confPantalla.largecomp.controles.num1.placeholder }    
                                                col=        { confPantalla.largecomp.controles.num1.col } 
                                                required=   { confPantalla.largecomp.controles.num1.required }
                                                readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largecomp.controles.num1.readonly }
                                                disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largecomp.controles.num1.disabled }
                                                alignRight= { confPantalla.largecomp.controles.num1.alignRight }
                                                change=     { handleCantidad }
                                                onBlur=     {null} 
                                            />
                                            <MiSelectLarge
                                                regActual={docSeleccionado ? docSeleccionado.id : 0}
                                                value={ubicacion}
                                                saveValue={saveUbicacion}                                                
                                                label={confPantalla.largecomp.controles.idubi.label.title}
                                                col={4}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.largecomp.controles.idubi.datatype}
                                                dataSql={confPantalla.largecomp.controles.idubi.data}
                                                multiLinea={confPantalla.largecomp.controles.idubi.multilinea}
                                                unidad={unidad}
                                                minCharSearch={0}
                                                readOnly={docBloqueado == true || docSeleccionado == null ? true : false}
                                            />
                                            <button 
                                                style={{marginTop: "32px"}} 
                                                id="btnaddline"
                                                className={"btn btn-flat btn-outline-success col-md-2 col-sm-12 mb-4" } 
                                                type="button" 
                                                onClick={ addLinea } 
                                                disabled={ docBloqueado == true || docSeleccionado == null ? true : false }
                                            >
                                                <i className="fal fa-plus"></i>
                                                {confPantalla.largecomp.controles.btnaddline.title}
                                            </button>                                         
                                        </FormRow>  

                                        {   loading == true ? 
                                                // <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                                //     <Spinner animation="border" />
                                                // </div>
                                                <SpinnerFloat  />
                                            :
                                            null
                                        }
                                        {/* {
                                        lineas != null
                                        ? */}
                                            <MiDataTableLarge 
                                                estadoForm= { "" }
                                                formulario={ {id:docSeleccionado} }
                                                id={"lineaslargecomp"}
                                                columnas={confPantalla.largecomp.controles.datatableres.columns}
                                                data={lineas}
                                                saveData={saveLineas}
                                                buttons={confPantalla.largecomp.controles.datatableres.buttons}
                                                ordering={confPantalla.largecomp.controles.datatableres.ordering}
                                                order={confPantalla.largecomp.controles.datatableres.order}
                                                searching={confPantalla.largecomp.controles.datatableres.searching}
                                                paging={confPantalla.largecomp.controles.datatableres.paging}
                                                select={confPantalla.largecomp.controles.datatableres.select}
                                                pagelength={confPantalla.largecomp.controles.datatableres.pagelength}                                                
                                                columnactions={confPantalla.largecomp.controles.datatableres.columnactions.title}
                                                linkColumns={confPantalla.largecomp.controles.datatableres.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                selectUbi={confPantalla.largecomp.controles.idubi}
                                                selectUni={confPantalla.largecomp.controles.iduni}
                                                inputNum1={confPantalla.largecomp.controles.num1}
                                                swaldelete={confPantalla.largecomp.swaldelete}  
                                                optionSelectUbi={[]} 
                                                optionSelectUni={[]}
                                                idFiltro={idFiltro}
                                                editar={btnEditLinea}
                                                importexcel={true}
                                                confPantalla={confPantalla}
                                                docBloqueado={docBloqueado}
                                                importExportFile={true}
                                                fnReloadTable={{fn: fnReloadTablaLineas, key: "iddoc"}}
                                                idRegImportExport={docSeleccionado ? docSeleccionado.id : null}
                                                saveLoadingTable={saveLoading} 
                                                controles={confPantalla.largecomp.controles}                                              
                                            />        
                                        {/* :
                                            null
                                        } */}

                                    </Section>                                    
                                    :
                                    <LoadingPage />
                                }
                            </Fragment>

                    }
                    {
                    showModalNewAlb == true
                    ?
                    <Modal
                        show={showModalNewAlb}
                        onHide={ () => saveShowModalNewAlb(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largecomp.controles.modalnew.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idCentro  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.largecomp.controles.modalnew.idcen.id }    
                                    name=        { confPantalla.largecomp.controles.modalnew.idcen.name }   
                                    label=       { confPantalla.largecomp.controles.modalnew.idcen.label }    
                                    placeholder= { confPantalla.largecomp.controles.modalnew.idcen.placeholder }
                                    col=         { confPantalla.largecomp.controles.modalnew.idcen.col } 
                                    isClearable= { confPantalla.largecomp.controles.modalnew.idcen.isclearable }
                                    isSearchable={ confPantalla.largecomp.controles.modalnew.idcen.issearchable }
                                    dataType=    { confPantalla.largecomp.controles.modalnew.idcen.datatype }
                                    data=        { confPantalla.largecomp.controles.modalnew.idcen.data }
                                    required=    { confPantalla.largecomp.controles.modalnew.idcen.required } 
                                    disabled=  { confPantalla.largecomp.controles.modalnew.idcen.disabled }
                                    readOnly =   { confPantalla.largecomp.controles.modalnew.idcen.readonly }
                                    disablethisid={confPantalla.largecomp.controles.modalnew.idcen.disablethisid}
                                    disableids={confPantalla.largecomp.controles.modalnew.idcen.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdCentro) }
                                    selectDirectIfOneOption={true}
                                    saveValSelect={saveIdCentro}
                                />
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idSelectPAlb  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largecomp.controles.modalnew.plantillas.id }    
                                    name=        { confPantalla.largecomp.controles.modalnew.plantillas.name }   
                                    label=       { confPantalla.largecomp.controles.modalnew.plantillas.label }    
                                    placeholder= { confPantalla.largecomp.controles.modalnew.plantillas.placeholder }
                                    col=         { confPantalla.largecomp.controles.modalnew.plantillas.col } 
                                    isClearable= { confPantalla.largecomp.controles.modalnew.plantillas.isclearable }
                                    isSearchable={ confPantalla.largecomp.controles.modalnew.plantillas.issearchable }
                                    dataType=    { confPantalla.largecomp.controles.modalnew.plantillas.datatype }
                                    data=        { confPantalla.largecomp.controles.modalnew.plantillas.data }
                                    required=    { confPantalla.largecomp.controles.modalnew.plantillas.required } 
                                    disabled=  { confPantalla.largecomp.controles.modalnew.plantillas.disabled }
                                    readOnly =   { confPantalla.largecomp.controles.modalnew.plantillas.readonly }
                                    disablethisid={confPantalla.largecomp.controles.modalnew.plantillas.disablethisid}
                                    disableids={confPantalla.largecomp.controles.modalnew.plantillas.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdSelectPAlb) }
                                />                             
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.fec1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.fec1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.fec1.name }   
                                    label=      { confPantalla.largecomp.controles.modalnew.fec1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.fec1.placeholder }    
                                    col=        { 3 } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.fec1.required }
                                    readonly=   { confPantalla.largecomp.controles.modaleditcabecera.fec1.readonly }
                                    disabled=   { confPantalla.largecomp.controles.modaleditcabecera.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Cab) }
                                    onBlur=     {null} 
                                />
                                
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.nom1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.nom1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.nom1.name }   
                                    label=      { confPantalla.largecomp.controles.modalnew.nom1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.nom1.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.nom1.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.nom1.required }
                                    readonly=   { confPantalla.largecomp.controles.modaleditcabecera.nom1.readonly }                                                
                                    disabled=   { confPantalla.largecomp.controles.modaleditcabecera.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.name }   
                                    label=      { confPantalla.largecomp.controles.modalnew.nom1_en.label}                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.nom1_en.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.required }
                                    readonly=   { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.readonly }                                                
                                    disabled=   { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>                           
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }
                            <p className="font-italic text-center">{ confPantalla.largecomp.controles.modalnew.required.title }</p>                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionNew }
                                        disabled={idCentro == 0 || idSelectPAlb == 0 || fec1Cab == "" || nom1Cab == "" || loadingActionModal == true ? true : false}
                                >
                                    {confPantalla.largecomp.controles.modalnew.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalNewAlb(false) }                                        
                                >
                                    {confPantalla.largecomp.controles.modalnew.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                    }
                    {
                    showModalEditCabecera == true
                    ?
                    <Modal
                        show={showModalEditCabecera}
                        onHide={ () => saveShowModalEditCabecera(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largecomp.controles.modaleditcabecera.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestCab  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largecomp.controles.modaleditcabecera.idest.id }    
                                    name=        { confPantalla.largecomp.controles.modaleditcabecera.idest.name }   
                                    label=       { confPantalla.largecomp.controles.modaleditcabecera.idest.label }    
                                    placeholder= { confPantalla.largecomp.controles.modaleditcabecera.idest.placeholder }
                                    col=         { confPantalla.largecomp.controles.modaleditcabecera.idest.col } 
                                    isClearable= { confPantalla.largecomp.controles.modaleditcabecera.idest.isclearable }
                                    isSearchable={ confPantalla.largecomp.controles.modaleditcabecera.idest.issearchable }
                                    dataType=    { confPantalla.largecomp.controles.modaleditcabecera.idest.datatype }
                                    data=        { confPantalla.largecomp.controles.modaleditcabecera.idest.data }
                                    required=    { confPantalla.largecomp.controles.modaleditcabecera.idest.required } 
                                    disabled=  { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.idest.disabled }
                                    readOnly =   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.idest.readonly }
                                    disablethisid={confPantalla.largecomp.controles.modaleditcabecera.idest.disablethisid}
                                    disableids={confPantalla.largecomp.controles.modaleditcabecera.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstCab) }
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.fec1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.fec1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.fec1.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.fec1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.fec1.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.fec1.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.fec1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.fec1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.fec2.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.fec2.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.fec2.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.fec2.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.fec2.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.fec2.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.fec2.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.fec2.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.fec3.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.fec3.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.fec3.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.fec3.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.fec3.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.fec3.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.fec3.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.fec3.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Cab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.nom1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.nom1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.nom1.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.nom1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.nom1.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.nom1.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.nom1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.nom1.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.nom1_en.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.nom1_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.nom1_en.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.notas.id }   
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.notas.name }
                                    rows=       { confPantalla.largecomp.controles.modaleditcabecera.notas.rows }      
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.notas.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.notas.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.notas.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.notas.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.notas.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasCab) }
                                    onBlur=     {null} 
                                />                            
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditcabecera.notas_en.id }   
                                    name=       { confPantalla.largecomp.controles.modaleditcabecera.notas_en.name }
                                    rows=       { confPantalla.largecomp.controles.modaleditcabecera.notas_en.rows }      
                                    label=      { confPantalla.largecomp.controles.modaleditcabecera.notas_en.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditcabecera.notas_en.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditcabecera.notas_en.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditcabecera.notas_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditcabecera.notas_en.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditcabecera.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <UplmPlusBtn
                                idReg={docSeleccionado.id}
                                id={ confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.id }
                                getAdj={confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.getadj}
                                // saveAdj={confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.saveadj}
                                estadoForm= { docBloqueado == true ? "readonly" : "" }                                    
                                col={12}
                                readonly={ confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.readonly }
                                traduction={confPantalla.config.trad.components}                                                            
                                datatable={ confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.datatable }
                                select={ confPantalla.largecomp.controles.modaleditcabecera.uplmplusbtn.select }
                                noBtn={true}
                                noModal={true}
                                saveAdjuntosParam={saveAdjuntosCabecera}

                            />
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditCabecera }
                                        disabled={ docBloqueado == true ? true : false}                                        
                                >
                                    {confPantalla.largecomp.controles.modaleditcabecera.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditCabecera(false) }                                        
                                >
                                    {confPantalla.largecomp.controles.modaleditcabecera.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                    {
                    showModalEditLinea == true
                    ?
                    <Modal
                        show={showModalEditLinea}
                        onHide={ () => saveShowModalEditLinea(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largecomp.controles.modaleditlinea.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestLin  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largecomp.controles.modaleditlinea.idest.id }    
                                    name=        { confPantalla.largecomp.controles.modaleditlinea.idest.name }   
                                    label=       { confPantalla.largecomp.controles.modaleditlinea.idest.label }    
                                    placeholder= { confPantalla.largecomp.controles.modaleditlinea.idest.placeholder }
                                    col=         { confPantalla.largecomp.controles.modaleditlinea.idest.col } 
                                    isClearable= { confPantalla.largecomp.controles.modaleditlinea.idest.isclearable }
                                    isSearchable={ confPantalla.largecomp.controles.modaleditlinea.idest.issearchable }
                                    dataType=    { confPantalla.largecomp.controles.modaleditlinea.idest.datatype }
                                    data=        { confPantalla.largecomp.controles.modaleditlinea.idest.data }
                                    required=    { confPantalla.largecomp.controles.modaleditlinea.idest.required } 
                                    disabled=  { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.idest.disabled }
                                    readOnly =   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.idest.readonly }
                                    disablethisid={confPantalla.largecomp.controles.modaleditlinea.idest.disablethisid}
                                    disableids={confPantalla.largecomp.controles.modaleditlinea.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstLin) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { num3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.num3.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.num3.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.num3.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.num3.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.num3.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.num3.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.num3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.num3.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.num3.disabled }
                                    change=     { e => handleInputModal(e, saveNum3Lin) }
                                    onBlur=     {null}
                                    alignRight= { true } 
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.fec1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.fec1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.fec1.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.fec1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.fec1.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.fec1.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.fec1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.fec1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.fec2.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.fec2.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.fec2.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.fec2.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.fec2.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.fec2.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.fec2.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.fec2.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.fec3.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.fec3.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.fec3.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.fec3.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.fec3.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.fec3.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.fec3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.fec3.readonly }        
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Lin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.nom1.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.nom1.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.nom1.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.nom1.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.nom1.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.nom1.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.nom1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.nom1.readonly }        
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.nom1_en.id }   
                                    type=       { confPantalla.largecomp.controles.modaleditlinea.nom1_en.type }  
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.nom1_en.name }   
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.nom1_en.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.nom1_en.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.nom1_en.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.nom1_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.nom1_en.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.notas.id }   
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.notas.name }
                                    rows=       { confPantalla.largecomp.controles.modaleditlinea.notas.rows }      
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.notas.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.notas.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.notas.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.notas.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.notas.readonly }            
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasLin) }
                                    onBlur=     {null} 
                                />                          
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largecomp.controles.modaleditlinea.notas_en.id }   
                                    name=       { confPantalla.largecomp.controles.modaleditlinea.notas_en.name }
                                    rows=       { confPantalla.largecomp.controles.modaleditlinea.notas_en.rows }      
                                    label=      { confPantalla.largecomp.controles.modaleditlinea.notas_en.label }                                                       
                                    placeholder={ confPantalla.largecomp.controles.modaleditlinea.notas_en.placeholder }    
                                    col=        { confPantalla.largecomp.controles.modaleditlinea.notas_en.col } 
                                    required=   { confPantalla.largecomp.controles.modaleditlinea.notas_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largecomp.controles.modaleditlinea.notas_en.readonly }        
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largecomp.controles.modaleditlinea.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>                            
                            <UplmPlusBtn
                                idReg={idLin}
                                id={ confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.id }
                                getAdj={confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.getadj}
                                // saveAdj={confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.saveadj}
                                estadoForm= { docBloqueado == true ? "readonly" : "" }                                    
                                col={12}
                                readonly={ confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.readonly }
                                traduction={confPantalla.config.trad.components}                                                            
                                datatable={ confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.datatable }
                                select={ confPantalla.largecomp.controles.modaleditlinea.uplmplusbtn.select }
                                noBtn={true}
                                noModal={true}
                                saveAdjuntosParam={saveAdjuntos}

                            />                            
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditLinea }
                                        disabled={ docBloqueado == true || loadingActionModal == true ? true : false}                                        
                                >
                                    {confPantalla.largecomp.controles.modaleditlinea.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditLinea(false) }
                                        disabled={ loadingActionModal == true ? true : false}                                        
                                >
                                    {confPantalla.largecomp.controles.modaleditlinea.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                </section>
            </div>
            <Footer />
        </div>
    );

}
export default LargeComp